import React from 'react';

export default function NoAnswers(props) {
    const { text } = props

    return <h5 style={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }} >
        {text || "No answers yet"}
    </h5>

}